import ModalReporte from "../ModalReporte"

export const VModalReporte = () => {
    return <ModalReporte />
}
export default VModalReporte